import { __decorate, __metadata } from 'tslib';
import { Component, NgModule } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiCModalModule } from '@wlp/ui-c-modal';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCPixConfirmationNotificationModalComponent = class UiCPixConfirmationNotificationModalComponent {
    constructor(modalController) {
        this.modalController = modalController;
        this.modalCanBeShown = true;
    }
    handleCheckboxChange(event) {
        this.modalCanBeShown = !event.target.checked;
    }
    dismiss() {
        this.modalController.dismiss({ data: this.modalCanBeShown });
    }
};
UiCPixConfirmationNotificationModalComponent = __decorate([
    Component({
        selector: 'ui-c-pix-confirmation-notification-modal',
        template: "<ui-c-modal class=\"pix-confirmation-notification-modal\" [dismissText]=\"'PIX.CONFIRMATION_NOTIFICATION_MODAL.DISMISS_BUTTON' | wlpTranslate\" (dismiss)=\"dismiss()\">\n  <div class=\"modal-title\">\n    <ion-icon size=\"large\" class=\"alert-circle\" name=\"alert-circle\"></ion-icon>\n    <h1>{{'PIX.CONFIRMATION_NOTIFICATION_MODAL.HEADER.TITLE' | wlpTranslate}}</h1>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"modal-message\">\n      <p>\n        {{'PIX.CONFIRMATION_NOTIFICATION_MODAL.FIRST_PARAGRAPH' | wlpTranslate}}\n      </p>\n      <p>\n        {{'PIX.CONFIRMATION_NOTIFICATION_MODAL.SECOND_PARAGRAPH' | wlpTranslate}}\n      </p>\n      <p>\n        {{'PIX.CONFIRMATION_NOTIFICATION_MODAL.THIRD_PARAGRAPH' | wlpTranslate}}\n      </p>\n    </div>\n    <div class=\"d-flex align-items-center visualization-check\">\n      <ion-checkbox mode=\"ios\" (ionChange)=\"handleCheckboxChange($event)\"></ion-checkbox>\n      <ion-text>{{'PIX.CONFIRMATION_NOTIFICATION_MODAL.VISUALIZATION_MESSAGE' | wlpTranslate}}</ion-text>\n    </div>\n  </div>\n</ui-c-modal>\n"
    }),
    __metadata("design:paramtypes", [ModalController])
], UiCPixConfirmationNotificationModalComponent);

let UiCPixConfirmationNotificationModalModule = class UiCPixConfirmationNotificationModalModule {
};
UiCPixConfirmationNotificationModalModule = __decorate([
    NgModule({
        declarations: [
            UiCPixConfirmationNotificationModalComponent
        ],
        imports: [
            CommonModule,
            IonicModule,
            UiCModalModule,
            UiBsTranslateModule,
            UiBsTranslateModule
        ],
        exports: [
            UiCPixConfirmationNotificationModalComponent
        ],
    })
], UiCPixConfirmationNotificationModalModule);

export { UiCPixConfirmationNotificationModalComponent, UiCPixConfirmationNotificationModalModule };
//# sourceMappingURL=wlp-ui-c-pix-confirmation-notification-modal.js.map
